import { interval } from 'rxjs';
import { map, take } from 'rxjs/operators';

export function countdownInSeconds(seconds: number) {
  return interval(1000).pipe(
    take(seconds),
    map((v) => seconds - 1 - v),
  );
}
